<template>
  <div>
    <div v-if="successPost" class="d-flex justify-content-center">
      <div class="alert alert-success text-center w-95" role="alert">
        <span class="font-weight-bold">Your insurance data has been saved successfully !</span><br>
        <span class="font-size-small">You can check your insurance data by clicking on "View Previous" button.</span>
        <button @click="hideShowAlertMessage" type="button" class="float-right btn btn-outline-secondary btn-sm">X</button>
      </div>
    </div>
    <form @submit.prevent="onSubmit">
      <div class="d-md-flex justify-content-between">
        <div class="d-flex w-md-45">
          <div class="d-flex justify-content-start">
            <p class="pLabel mb-0"><span class="font-weight-bold">Title :</span></p>
            <div class="ml-3">
              <div class="custom-control custom-radio custom-control-inline" :key="index" v-for="(value, index) of title">
                <input @blur="$v.userDataForm.title.$touch()" v-model="userDataForm.title" type="radio" :value="value" :id="value" name="clientTitle" class="custom-control-input">
                <label class="custom-control-label" :for="value">{{ value }}</label>
              </div>
            </div>
          </div>
          <div v-if="$v.userDataForm.title.$error">
            <span v-if="!$v.userDataForm.title.required" class="text-danger">* Please choose your title !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.firstname.$touch()" v-model="userDataForm.firstname" type="text" name="clientFirstName" id="clientFirstName" class="form-control" placeholder="First Name">
            <div class="input-group-append">
              <label for="clientFirstName" class="input-group-text bg-color-grey text-white">First Name</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.firstname.$error">
            <span v-if="!$v.userDataForm.firstname.minLength" class="text-danger">* First name must have at least {{ $v.userDataForm.firstname.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.firstname.minLength && !$v.userDataForm.firstname.required">
            <span v-if="!$v.userDataForm.firstname.required" class="text-danger">* Please enter your first name !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3 mt-md-0">
          <div class="input-group">
            <input @blur="$v.userDataForm.middlename.$touch()" v-model="userDataForm.middlename" type="text" name="clientMiddleName" id="clientMiddleName" class="form-control" placeholder="Middle Name">
            <div class="input-group-append">
              <label for="clientMiddleName" class="input-group-text bg-color-grey text-white">Middle Name</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.middlename.$error">
            <span v-if="!$v.userDataForm.middlename.minLength" class="text-danger">* Middle name must have at least {{ $v.userDataForm.middlename.$params.minLength.min }} characters !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.lastname.$touch()" v-model="userDataForm.lastname" type="text" name="clientLastName" id="clientLastName" class="form-control" placeholder="Last Name">
            <div class="input-group-append">
              <label for="clientLastName" class="input-group-text bg-color-grey text-white">Last Name</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.lastname.$error">
            <span v-if="!$v.userDataForm.lastname.minLength" class="text-danger">* Last name must have at least {{ $v.userDataForm.lastname.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.lastname.minLength && !$v.userDataForm.lastname.required">
            <span v-if="!$v.userDataForm.lastname.required" class="text-danger">* Please enter your last name !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="d-flex">
          <div class="d-flex justify-content-start">
            <p class="pLabel w-25 mt-3"><span class="font-weight-bold">Marital Status :</span></p>
            <div class="mt-3 ml-3">
              <div class="custom-control custom-radio custom-control-inline" :key="index" v-for="(value, index) of maritalstatus">
                <input @blur="$v.userDataForm.maritalstatus.$touch()" v-model="userDataForm.maritalstatus" type="radio" :value="value" :id="value" name="clientMaritalStatus" class="custom-control-input">
                <label class="custom-control-label" :for="value">{{ value }}</label>
              </div>
            </div>
          </div>
          <div v-if="$v.userDataForm.maritalstatus.$error">
            <span v-if="!$v.userDataForm.maritalstatus.required" class="text-danger">* Please enter your marital status !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.phonenumber.$touch()" v-model="userDataForm.phonenumber" type="tel" name="clientPhoneNumber" id="clientPhoneNumber" class="form-control" placeholder="Phone Number">
            <div class="input-group-append">
              <label for="clientPhoneNumber" class="input-group-text bg-color-grey text-white">Telephone</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.phonenumber.$error">
            <span v-if="!$v.userDataForm.phonenumber.minLength" class="text-danger">* Please a phone number with at least {{ $v.userDataForm.phonenumber.$params.minLength.min }} digits !</span>
            <br v-if="!$v.userDataForm.phonenumber.minLength && !$v.userDataForm.phonenumber.numeric">
            <span v-if="!$v.userDataForm.phonenumber.numeric" class="text-danger">* Phone number must contain only digits !</span>
            <br v-if="!$v.userDataForm.phonenumber.numeric && !$v.userDataForm.phonenumber.required">
            <span v-if="!$v.userDataForm.phonenumber.required" class="text-danger">* Please enter a phone number !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.email.$touch()" v-model="userDataForm.email" type="email" name="clientEmail" id="clientEmail" class="form-control" placeholder="Email Address">
            <div class="input-group-append">
              <label for="clientEmail" class="input-group-text bg-color-grey text-white">Email Address</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.email.$error">
            <span v-if="!$v.userDataForm.email.email" class="text-danger">* Please enter a valid email address !</span>
            <br v-if="!$v.userDataForm.email.email && !$v.userDataForm.email.required">
            <span v-if="!$v.userDataForm.email.required" class="text-danger">* Please enter email address !</span>
          </div>
        </div>
        <div class="form-group w-md-45 mt-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <label class="input-group-text bg-color-grey text-white" for="clientCountry">Country</label>
            </div>
            <select @blur="$v.userDataForm.country.$touch()" v-model="userDataForm.country" class="form-control" name="clientCountry" id="clientCountry">
              <option value="no">Select a country</option>
              <optgroup :key="continent" :id="'country-optgroup-' + continent" :label="continent" v-for="(countries, continent) in listOfCountries">
                <option :key="index" :value="country[1]" :label="country[1] + ' (' + country[0] + ')' "  v-for="(country, index) of countries">
                  {{ country[1] }} ({{ country[0] }})
                </option>
              </optgroup>
            </select>
          </div>
          <div v-if="$v.userDataForm.country.$error">
            <span v-if="!$v.userDataForm.country.minLength" class="text-danger">* Please enter a valid country</span>
            <br v-if="!$v.userDataForm.country.minLength && !$v.userDataForm.country.required">
            <span v-if="!$v.userDataForm.country.required" class="text-danger">* Please choose your country !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <div class="input-group-append">
              <label for="clientDateOfBirth" class="input-group-text bg-color-grey text-white">Birth Date</label>
            </div>
            <input @blur="$v.userDataForm.datebirth.$touch()" v-model="userDataForm.datebirth" type="date" max="2001-01-01" name="clientDateOfBirth" id="clientDateOfBirth" class="form-control" placeholder="01/12/2015">
          </div>
          <div v-if="$v.userDataForm.datebirth.$error">
            <span v-if="!$v.userDataForm.datebirth.required" class="text-danger">* Please enter your birth date !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.occupation.$touch()" v-model="userDataForm.occupation" type="text" name="clientOccupation" id="clientOccupation" class="form-control" placeholder="Occupation">
            <div class="input-group-append">
              <label for="clientOccupation" class="input-group-text bg-color-grey text-white">Occupation</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.occupation.$error">
            <span v-if="!$v.userDataForm.occupation.minLength" class="text-danger">* Occupation field must have at least {{ $v.userDataForm.occupation.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.occupation.minLength && !$v.userDataForm.occupation.required">
            <span v-if="!$v.userDataForm.occupation.required" class="text-danger">* Please enter your occupation !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.address.$touch()" v-model="userDataForm.address" type="text" name="clientAddress" id="clientAddress" class="form-control" placeholder="Home address">
            <div class="input-group-append">
              <label for="clientAddress" class="input-group-text bg-color-grey text-white">Home Address</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.address.$error">
            <span v-if="!$v.userDataForm.address.minLength" class="text-danger">* Address must have at least {{ $v.userDataForm.address.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.address.minLength && !$v.userDataForm.address.required">
            <span v-if="!$v.userDataForm.address.required" class="text-danger">* Please enter home address !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3">
          <div class="d-flex justify-content-start">
            <p class="pLabel w-25"><span class="font-weight-bold">Type of home :</span></p>
            <div class="ml-3">
              <div class="custom-control custom-radio custom-control-inline" :key="index" v-for="(value, index) of typehome">
                <input @blur="$v.userDataForm.typehome.$touch()" v-model="userDataForm.typehome" type="radio" :value="value" :id="value" name="clientTypeHome" class="custom-control-input">
                <label class="custom-control-label" :for="value">{{ value }}</label>
              </div>
            </div>
          </div>
          <div v-if="$v.userDataForm.typehome.$error">
            <span v-if="!$v.userDataForm.typehome.required" class="text-danger">* Please select your home type !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.buildingage.$touch()" v-model="userDataForm.buildingage" type="number" name="clientBuildingAge" id="clientBuildingAge" class="form-control" placeholder="Building Age">
            <div class="input-group-append">
              <label for="clientBuildingAge" class="input-group-text bg-color-grey text-white">Building Age</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.buildingage.$error">
            <span v-if="!$v.userDataForm.buildingage.between" class="text-danger">* Building age must be between {{ $v.userDataForm.buildingage.$params.between.min }} and {{ $v.userDataForm.buildingage.$params.between.max }}</span>
            <br v-if="!$v.userDataForm.buildingage.numeric && !$v.userDataForm.buildingage.between">
            <span v-if="!$v.userDataForm.buildingage.numeric" class="text-danger">* This field can contain only digits</span>
            <br v-if="!$v.userDataForm.buildingage.numeric && !$v.userDataForm.buildingage.required">
            <span v-if="!$v.userDataForm.buildingage.required" class="text-danger">* Please enter building age !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3">
          <div class="d-flex justify-content-start">
            <p class="pLabel w-30"><span class="font-weight-bold">Ownership Status :</span></p>
            <div class="ml-3">
              <div class="custom-control custom-radio custom-control-inline" :key="index" v-for="(value, index) of ownershipstatus">
                <input @blur="$v.userDataForm.ownershipstatus.$touch()" v-model="userDataForm.ownershipstatus" type="radio" :value="value" :id="value" name="clientOwnershipStatus" class="custom-control-input">
                <label class="custom-control-label" :for="value">{{ value }}</label>
              </div>
            </div>
          </div>
          <div v-if="$v.userDataForm.ownershipstatus.$error">
            <span v-if="!$v.userDataForm.ownershipstatus.required" class="text-danger">* Please select your ownership status !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <div class="input-group-append">
              <label for="clientInsuranceStart" class="input-group-text bg-color-grey text-white">Insurance Start Date</label>
            </div>
            <input @blur="$v.userDataForm.insurancestart.$touch()" v-model="userDataForm.insurancestart" type="date" min="2019-06-30" name="clientInsuranceStart" id="clientInsuranceStart" class="form-control" placeholder="30/05/2019">
          </div>
          <div v-if="$v.userDataForm.insurancestart.$error">
            <span v-if="!$v.userDataForm.insurancestart.required" class="text-danger">* Please enter the starting date of your insurance !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3">
          <div class="d-flex justify-content-start">
            <p class="pLabel w-30"><span class="font-weight-bold">Type of cover :</span></p>
            <div class="ml-3">
              <div class="custom-control custom-radio custom-control-inline" :key="index" v-for="(value, index) of typecover">
                <input @blur="$v.userDataForm.typecover.$touch()" v-model="userDataForm.typecover" type="radio" :value="value" :id="value" name="clientTypeCover" class="custom-control-input">
                <label class="custom-control-label" :for="value">{{ value }}</label>
              </div>
            </div>
          </div>
          <div v-if="$v.userDataForm.typecover.$error">
            <span v-if="!$v.userDataForm.typecover.required" class="text-danger">* Please select your cover type !</span>
          </div>
        </div>
      </div>
      <div class="text-center mb-5">
        <button type="submit" class="mt-5 btn bg-color-grey text-white" :disabled="$v.userDataForm.$invalid">Submit</button>
        <div class="divEmptyBox text-center" v-if="$v.userDataForm.$invalid" v-on:click="$store.state.invalidFormAlert">
          <div class="emptyBox"><span class="invisible">Submit</span></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { FORM_HOME_VALIDATIONS } from '../../../../validations/formHome'
export default {
  name: 'InsuranceFormHome',
  // Get insurance type selected by user and fontStyle
  props: {
    insuranceType: {
      type: String
    },
    defaultFontStyle: {
      type: String,
      default: 'normal'
    }
  },
  data () {
    return {
      listOfCountries: this.$store.state.countries,
      years: this.$store.state.years,
      title: this.$store.state.title,
      maritalstatus: this.$store.state.maritalstatus,
      typehome: this.$store.state.typehome,
      ownershipstatus: this.$store.state.ownershipstatus,
      typecover: this.$store.state.typecover,
      userDataForm: {
        title: null,
        firstname: null,
        middlename: null,
        lastname: null,
        maritalstatus: null,
        phonenumber: null,
        email: null,
        country: null,
        datebirth: null,
        occupation: null,
        address: null,
        typehome: null,
        buildingage: null,
        ownershipstatus: null,
        insurancestart: null,
        typecover: null
      },
      successPost: false
    }
  },
  methods: {
    // show success message if insurance data have been posted successfully
    hideShowAlertMessage () {
      this.successPost = !this.successPost
    },
    // Post insurance object after successfully submission
    onSubmit () {
      let type = null
      this.insuranceType === 'AppInsuranceFormHome' ? type = 'Home' : type = null
      console.log('insuranceType = ' + type)
      const formData = {
        typeinsurance: type,
        ownerinsurance: this.$store.getters.email,
        title: this.userDataForm.title,
        firstname: this.userDataForm.firstname,
        middlename: this.userDataForm.middlename,
        lastname: this.userDataForm.lastname,
        maritalstatus: this.userDataForm.maritalstatus,
        phonenumber: this.userDataForm.phonenumber,
        email: this.userDataForm.email,
        country: this.userDataForm.country,
        datebirth: this.userDataForm.datebirth,
        occupation: this.userDataForm.occupation,
        address: this.userDataForm.address,
        typehome: this.userDataForm.typehome,
        buildingage: this.userDataForm.buildingage,
        ownershipstatus: this.userDataForm.ownershipstatus,
        insurancestart: this.userDataForm.insurancestart,
        typecover: this.userDataForm.typecover
      }
      console.log(formData)
      this.$store.dispatch('postInsurance', formData)
        .then(isSuccess => {
          isSuccess === true ? this.successPost = true : this.successPost = false
          console.log('response axios post insurance = ' + isSuccess)
        })
    }
  },
  // Load validations requirements of the insurance form
  validations: FORM_HOME_VALIDATIONS
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/insurances/forms/InsuranceFormHome.vue